module.exports = __webpack_public_path__ + "static/media/the-blue-mosque.87c7da63.jpg";